import classNames from 'classnames';
import styles from './Button.module.scss';

export interface ButtonProps {
	children?: React.ReactNode;
	style?: 'primary' | 'primarySmall' | 'primarySquare' | 'primarySmallSquare' | 'secondary' | 'secondarySmall' | 'secondarySquare' | 'secondarySmallSquare';
	title?: string;
	className?: string;
	type?: 'button' | 'submit' | 'reset';
	disabled?: boolean;
	onClick?: (e) => void;
	onKeyDown?: (e) => void;
	icon?: any;
	ref?: any;
	ariaLabel?: string;
	id?: string;
	colorOverride?: { color?: string; backgroundColor?: string };
}

export const Button: React.FC<ButtonProps> = ({ children, style, title, className, type, disabled, onClick, icon, ref, ariaLabel, id, colorOverride, ...rest }) => (
	<button
		type={type || 'button'}
		title={title}
		className={classNames(styles.Button, styles[`Button___${style}`], className)}
		disabled={disabled}
		aria-disabled={disabled}
		onClick={onClick}
		ref={ref}
		aria-label={ariaLabel}
		id={id}
		style={
            colorOverride
                ? ({
                      '--button-color-override': colorOverride.color,
                      '--button-bg-override': colorOverride.backgroundColor,
					  '--button-border-override': colorOverride.backgroundColor,
                  } as React.CSSProperties)
                : undefined
        }
        {...rest} 
	>
		<span>{children}</span>
		{icon}
	</button>
);
